/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A curated, ordered collection of an author's courses with its own slug.
 */
export type Catalog = {
    id?: string;
    slug?: string;
    title?: string;
    description?: string;
    status?: Catalog.status;
    position?: number;
    /**
     * Courses currently in the catalog (any status).
     */
    courseCount?: number;
    createdAt?: string;
    updatedAt?: string;
};
export namespace Catalog {
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
    }
}

